<template>
  <div id="EditIntention">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/intentionList?skillId='+this.skill_id +'&online='+this.online_num}">意图列表</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/systemList?skillId='+this.skill_id +'&online='+this.online_num }">系统意图列表</el-breadcrumb-item>
      <el-breadcrumb-item>系统意图详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="intentionInfo">
      <div class="title">意图详情</div>
      <div class="container-msg">
       <p v-html="intentInfo[intent_id]"></p>
        <el-button type="primary" round size="mini" @click="refCancel">{{link}}</el-button>
      </div>
    </div>
    <div class="intentionInfo">
    <div class="title">用户表达示意</div>
    <div class="container-msg">
      <ul>
        <li v-for="val in expressions">{{val}}</li>
      </ul>
      <div id="button"><el-button type="primary" round @click="back">返回意图列表</el-button></div>
    </div>

    </div>

  </div>
</template>
<script>
  import qs from 'qs'
  import {getSysIntApi, refSysIntApi, calSysIntApi} from '@/api'
  export default {
    data() {
      return {
        skill_id: '',
        online_num:'',
        intent_id: '',
        ref_state: '',
        link: '',
        expressions: [],
        intentInfo:{
          'dAaRWibiU3G37fn2myqPw5': '下一个意图应用于用户希望切换到下一个资源的对话场景。下一个意图解析结果会发送到开发者技能网关。',
          'hGz4q6Q5S3PDMAXRPouqtM': '上一个意图应用于用户希望切换到上一个资源的对话场景。上一个意图解析结果会发送到开发者技能网关。',
          'kHvsPxfkzGfky44Ux6YefK': '取消意图应用于用户希望取消或中断对话的场景。取消意图的解析结果会发送到开发者技能网关。<br>特殊场景：在意图确认的特殊场景中，必须引用取消意图，如果用户触发了取消意图，则承载意图确认的意图交互模型的解析结果不会发送到开发者技能网关。',
          'PrWFTG27xCSe9C5JkzG6S6': '确认意图应用于用户表示肯定的对话场景。确认意图的解析结果会发送到开发者技能网关。<br>特殊场景：在意图确认的特殊场景中，必须引用确认意图，如果用户触发了确认意图，则承载意图确认的意图交互模型的解析结果将发送到开发者技能网关。',
          'ui92R9DtvQRR3ua7TVhAbb': '继续意图应用于用户希望继续对资源进行调用/播放的对话场景。继续意图的解析结果会发送到开发者技能网关。'
        }
      }
    },
    created () {
      this.getInt()
    },
    computed: {},
    watch: {},
    methods: {
      async getInt () {// 获取意图详情
        this.skill_id = this.$route.query.skillId
        this.online_num = this.$route.query.online
        this.ref_state = this.$route.query.ref_state
        this.$route.query.ref_state == 'true' ? this.link = '取消引用' : this.link = '引用'
        this.intent_id = this.$route.query.intent_id
        let res = await getSysIntApi(this.$route.query.intent_id)
        if (res.data.code == 200) {
            this.expressions = res.data.data.expressions
        } else {
          this.$message({message: '获取意图详情失败', type: 'error'})
        }

      },
      async refCancel () {//取消/引用
        if (this.ref_state == 'true' || this.ref_state == true) {
          let res = await calSysIntApi(qs.stringify({skill_id: this.skill_id, intents: [this.$route.query.intent_id]}))
          this.ref_state = false
          this.link = '引用'
        } else {
          let res = await refSysIntApi(qs.stringify({skill_id: this.skill_id, intents: [this.$route.query.intent_id]}))
          this.ref_state = true
          this.link = '取消引用'

        }
      },
      back () {
        this.$router.back(-2)
      }
    }
  }
</script>
<style  rel="stylesheet/scss" lang="scss">
  #EditIntention{
    background:#f7f7f7;
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    .intentionInfo{
      &:nth-child(2){
        margin:20px 0;
      }
      background:#fff;
      .container{
        padding:30px;
        p{
          margin-bottom:25px;
        }
        ul{
          list-style: none;
          li{
            list-style: none;
            height:40px;
            color:#808080;
          }
        }
      }
    }
    .container-msg{
      padding: 30px;
      ul {
        padding-left:10px;
      }
    }
    #button{
      background:#fff;
      margin-top: 20px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skill/intention/IntentionDeatil.vue